import styled from "@emotion/styled";

import { PropertiesPanel } from "@skilitics/designer-ui-components";

import { useHidePanels } from "../application";
import { PickingShield } from "../composable/picking";
import { PROPERTY_PANEL_ANCHOR_ID } from "./constants";
import { useIsTriggersOpen } from "./useSelectedAspect";
import { useSelectedNode, useSelectedNodeActions } from "./useSelectedNode";

type Props = {
  multiSelectEnabled?: boolean;
};

export const PropertiesPanelView = ({ multiSelectEnabled }: Props) => {
  const selectedNode = useSelectedNode();
  const nodeActions = useSelectedNodeActions();
  const [hidePanels] = useHidePanels();
  const isTriggersOpen = useIsTriggersOpen();

  return (
    <PropertiesPanel
      title={selectedNode?.title}
      contextActions={nodeActions}
      disableKeyboardShortcuts={isTriggersOpen}
      disabled={multiSelectEnabled}
      hidden={hidePanels}
    >
      <PickingShield />
      {/* the selected node is teleported into here from <NodeDesigner view="details"/> */}
      <PropertiesPanelAnchor id={PROPERTY_PANEL_ANCHOR_ID} onClick={(e) => e.stopPropagation()} />
    </PropertiesPanel>
  );
};

const PropertiesPanelAnchor = styled.div`
  display: contents;
`;
